@if(data.length){
    <white-label-horizontal-carousel [stepWidth]="300" [showCarets]="true" [interval]="4000">
        <!-- Each item is a template. You can add a directive if desired. -->
        @for(item of contentData(); track item;){
            <ng-template #item>
                <div class="min-w-72 mx-2">
                    <app-service-item-card [product]="item"></app-service-item-card>
                </div>

            </ng-template>
        }
    </white-label-horizontal-carousel>
}





